/**
 * localStorage keys for Truva session + translate prefs.
 */

export const SESSION_KEY = 'truva_session';
export const TRANSLATE_SETTINGS_KEY = 'truva_translate_settings';
export const DISPLAY_TIMEZONE_KEY = 'truva_display_timezone';

export function readStored(key) {
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

export function writeStored(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (_) {}
}

export function migrateLegacyKeys() {
  // No-op retained so older imports that call migrateLegacyKeys() still load.
}

migrateLegacyKeys();
